export const JDInstallEvaluateColumns = [
  { title: "商品编码", field: "productCode", width: 120 },
  { title: "商品名称", field: "productName", width: 150 },
  { title: "商品型号", field: "productModel", width: 120 },
  { title: "商品一级分类名称", field: "firstCategoryName", width: 150 },
  { title: "商品二级分类名称", field: "secondCategoryName", width: 150 },
  { title: "商品三级分类名称", field: "thirdCategoryName", width: 150 },
  { title: "排名品类", field: "rankingCategory", width: 120 },
  { title: "品牌编码", field: "brandCode", width: 120 },
  { title: "品牌中文名称", field: "brandChineseName", width: 150 },
  { title: "省份", field: "province", width: 100 },
  { title: "城市", field: "city", width: 100 },
  { title: "区县", field: "district", width: 100 },
  { title: "店铺ID", field: "shopId", width: 120 },
  { title: "店铺名称", field: "shopName", width: 150 },
  { title: "订单编号", field: "orderNumber", width: 150 },
  { title: "购买时间", field: "purchaseTime", width: 150 },
  { title: "模式", field: "mode", width: 100 },
  { title: "工单号", field: "workOrderNo", width: 150 },
  { title: "工单状态", field: "workOrderStatus", width: 120 },
  { title: "类型", field: "type", width: 100 },
  { title: "创建时间", field: "createTime", width: 150 },
  { title: "安装类型", field: "installationType", width: 120 },
  { title: "完工时间", field: "completionTime", width: 150 },
  { title: "评价时间", field: "evaluationTime", width: 150 },
  { title: "是否差评", field: "isNegativeReview", width: 100 },
  { title: "时效评价", field: "timelinessEvaluation", width: 120 },
  { title: "费用评价", field: "costEvaluation", width: 120 },
  { title: "服务评价", field: "serviceEvaluation", width: 120 },
  { title: "服务评价内容", field: "serviceEvaluationContent", width: 200 },
  { title: "商品评价时间", field: "productEvaluationTime", width: 150 },
  { title: "商品评价", field: "productEvaluation", width: 120 },
  { title: "商品评价内容", field: "productEvaluationContent", width: 200 },
  { title: "二次安装评价", field: "reinstallationEvaluation", width: 150 },
  {
    title: "二次安装评价内容",
    field: "reinstallationEvaluationContent",
    width: 200,
  },
  { title: "标签", field: "tags", width: 120 },
  { title: "指标类型", field: "indicatorType", width: 120 },
  { title: "履约服务商", field: "fulfillmentServiceProvider", width: 150 },
  { title: "履约商网点", field: "serviceProviderNetwork", width: 150 },
];

export const JDSatisfactionColumns = [
  { title: "评价时间", field: "evaluationTime", width: 150 },
  { title: "商品编码", field: "productCode", width: 120 },
  { title: "商品名称", field: "productName", width: 150 },
  { title: "商品型号", field: "productModel", width: 120 },
  { title: "一级类目", field: "firstCategory", width: 150 },
  { title: "二级类目", field: "secondCategory", width: 150 },
  { title: "三级类目", field: "thirdCategory", width: 150 },
  { title: "排名品类", field: "rankingCategory", width: 120 },
  { title: "模式", field: "mode", width: 100 },
  { title: "主品牌id", field: "mainBrandId", width: 120 },
  { title: "主品牌名称", field: "mainBrandName", width: 150 },
  { title: "服务单号", field: "serviceOrderNo", width: 150 },
  { title: "订单号", field: "orderNo", width: 150 },
  { title: "工单号", field: "workOrderNo", width: 150 },
  { title: "店铺id", field: "shopId", width: 120 },
  { title: "店铺名称", field: "shopName", width: 150 },
  { title: "取件省", field: "pickupProvince", width: 100 },
  { title: "取件市", field: "pickupCity", width: 100 },
  { title: "售后服务单申请时间", field: "afterSalesApplyTime", width: 150 },
  { title: "客户问题描述", field: "customerIssueDescription", width: 200 },
  { title: "客户申请处理方式", field: "customerRequestType", width: 150 },
  { title: "满意度投票时间", field: "satisfactionVoteTime", width: 150 },
  { title: "评价得分", field: "evaluationScore", width: 120 },
  { title: "评价内容", field: "evaluationContent", width: 200 },
  { title: "满意度标识", field: "satisfactionFlag", width: 120 }
];

export const JDBuyShopExcludeColumns = [
  { title: "序号", field: "no", width: 150 },
  { title: "店铺", field: "buyShop", width: 120 },
  { title: "模式", field: "mode", width: 150 },
  { title: "备注", field: "memo", width: 120 }
]

export const ServiceProviderRegionColumns = [
  { title: "系统服务商名称", field: "systemServiceProviderName", width: 150 },
  { title: "服务经理", field: "serviceManager", width: 120 },
  { title: "服务省份", field: "serviceProvince", width: 120 },
  { title: "实际服务商名称", field: "actualServiceProviderName", width: 150 },
  { title: "线上赛道所属赛区", field: "onlineTrackRegion", width: 150 },
  { title: "线下赛道所属赛区", field: "offlineTrackRegion", width: 150 },
  { title: "新零售赛道所属赛区", field: "newRetailTrackRegion", width: 150 }
];


export const JDDeliveryInfoColumns =  [
  { title: '销售模式', field: 'salesModel' },
  { title: '工单号', field: 'workOrderNo' },
  { title: '销售订单号', field: 'salesOrderNo' },
  { title: '用户所在省', field: 'userProvince' },
  { title: '用户所在市', field: 'userCity' },
  { title: '用户所在区县', field: 'userDistrict' },
  { title: '销售订单状态', field: 'salesOrderStatus' },
  { title: '主品sku', field: 'mainSku' },
  { title: '商品名称', field: 'productName' },
  { title: '一级类目', field: 'categoryLevel1' },
  { title: '二级类目', field: 'categoryLevel2' },
  { title: '三级类目', field: 'categoryLevel3' },
  { title: '品牌名称', field: 'brandName' },
  { title: '工单状态', field: 'workOrderStatus' },
  { title: '服务类型', field: 'serviceType' },
  { title: '是否零售', field: 'isRetail' },
  { title: '履约服务商', field: 'fulfillmentServiceProvider' },
  { title: '履约商网点', field: 'fulfillmentServicePoint' },
  { title: '购买时间', field: 'purchaseTime', formatter: 'formatDate' },
  { title: '预约送货时间', field: 'scheduledDeliveryTime', formatter: 'formatDate' },
  { title: '出库时间', field: 'outboundTime', formatter: 'formatDate' },
  { title: '服务单创建时间', field: 'serviceOrderCreateTime', formatter: 'formatDate' },
  { title: '下传时间', field: 'downloadTime', formatter: 'formatDate' },
  { title: '接出时间', field: 'pickupTime', formatter: 'formatDate' },
  { title: '物流妥投时间', field: 'deliveryTime', formatter: 'formatDate' },
  { title: '首次预约上门时间', field: 'firstAppointmentTime', formatter: 'formatDate' },
  { title: '最后预约上门时间', field: 'lastAppointmentTime', formatter: 'formatDate' },
  { title: '派单时间', field: 'dispatchTime', formatter: 'formatDate' },
  { title: '取消时间', field: 'cancelTime', formatter: 'formatDate' },
  { title: '完工时间', field: 'completionTime', formatter: 'formatDate' },
  { title: '用户安装评价时间', field: 'userInstallEvaluationTime', formatter: 'formatDate' },
  { title: '服务满意度评价', field: 'serviceSatisfactionRating' },
  { title: '服务费用评价', field: 'serviceCostRating' },
  { title: '服务时效评价', field: 'serviceEfficiencyRating' },
  { title: '评价标签', field: 'evaluationTags' },
  { title: '评价内容', field: 'evaluationContent' }
];

export const TmDeliveryInfoColumns = [
  { field: 'id', title: '工单id' },
  { field: 'parentOrderId', title: '实物交易-父订单' },
  { field: 'childOrderId', title: '实物交易-子订单' },
  { field: 'deliveryTime', title: '实物交易-发货时间' },
  { field: 'signTime', title: '实物交易-签收时间' },
  { field: 'brandName', title: '实物交易-品牌名称' },
  { field: 'shopName', title: '实物交易-店铺名称' },
  { field: 'productName', title: '实物交易-商品名称' },
  { field: 'industryGroup', title: '实物交易-行业大组' },
  { field: 'firstLevelIndustry', title: '实物交易-一级行业' },
  { field: 'secondLevelIndustry', title: '实物交易-二级行业' },
  { field: 'leafCategory', title: '实物交易-叶子类目' },
  { field: 'createTime', title: '工单-创建时间' },
  { field: 'statusId', title: '工单-状态id' },
  { field: 'statusName', title: '工单-状态名称' },
  { field: 'serviceProviderName', title: '工单-服务商名称' },
  { field: 'serviceChildOrderId', title: '服务交易-子订单' },
  { field: 'receiveProvince', title: '收货省份' },
  { field: 'receiveCity', title: '收货城市' },
  { field: 'receiveDistrict', title: '收货区县' },
  { field: 'dispatchTime', title: '派单时间' },
  { field: 'firstAppointmentTime', title: '首次预约时间' },
  { field: 'firstServiceStartTime', title: '首次预约服务开始时间' },
  { field: 'firstServiceEndTime', title: '首次预约服务结束时间' },
  { field: 'lastAppointmentTime', title: '末次预约时间' },
  { field: 'lastServiceStartTime', title: '末次预约服务开始时间' },
  { field: 'lastServiceEndTime', title: '末次预约服务结束时间' },
  { field: 'appointmentCount', title: '预约次数' },
  { field: 'rescheduleCount', title: '改约次数' },
  { field: 'firstServiceCompleteOrFailTime', title: '首次服务完成或失败时间' },
  { field: 'lastServiceCompleteOrFailTime', title: '末次服务完成或失败时间' },
  { field: 'onTimeCompletion', title: '是否准时完结' },
  { field: 'reviewTime', title: '评价时间' },
  { field: 'reviewScore', title: '评价分数' },
  { field: 'reviewContentLabel', title: '评价内容标签' }
];
